import { render, staticRenderFns } from "./ModelActivities.vue?vue&type=template&id=3d79306b&"
import script from "./ModelActivities.vue?vue&type=script&lang=js&"
export * from "./ModelActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports